import {useAlertStore} from "../stores/alert";

export default defineNuxtPlugin(() => {
  const router = useRouter()
  const alertStore = useAlertStore()

  router.beforeEach((to, from) => {
    if (from?.path === '/login' && to.path !== '/login') {
      alertStore.clearAllAlerts()
    }
  })
})